import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const EyeIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Eye`} {...props}>
    <Path
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 13c3.866 0 7-5 7-5s-3.134-5-7-5-7 5-7 5 3.134 5 7 5Z"
    />
    <Circle cx={8} cy={8} r={2} fill="currentColor" />
  </Icon>
);
